<template>
  <div class="float-left boss-check-container boss-batch-select">
    全
    <span
      class="boss-check-number"
      data-test="selector-check-number"
    >{{ displayCount }}</span>名<template v-if="showSelector">
      <span data-test="page-label">{{ countPageLabel }}</span><template v-if="showSelector">
        <span data-test="selector-label-start">    このページの先頭から</span>
        <input
          v-model="selectLength"
          class="boss-input"
          data-test="selector-input"
          type="number"
          :max="Number.MAX_SAFE_INTEGER"
          min="0"
          @keypress="onlyNumberInRange($event)"
        >名を
        <button
          class="boss-button boss-exe-button pega-button pega-mr-5 pega-bulk-button"
          data-test="all-checked-on"
          @click="allCheckedOn()"
        >
          <span class="boss-exe-button-text">選択する</span>
        </button>
        <button
          class="boss-button boss-exe-button pega-button pega-mr-5 pega-bulk-button"
          data-test="all-checked-off"
          @click="allCheckedOff()"
        >
          <span class="boss-exe-button-text">全て解除する</span>
        </button>
      </template>
    </template>
  </div>
</template>

<script>
import eventValidations from '@/lib/eventValidations'
export default {
  mixins: [eventValidations],
  props: {
    displayCount: {
      type: Number,
      default: 0
    },
    countFrom: {
      type: Number,
      default: 0
    },
    countTo: {
      type: Number,
      default: 0
    },
    isPaging: {
      type: Boolean,
      default: false
    },
    showSelector: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isChecked: false,
      selectLength: this.displayCount
    }
  },
  computed: {
    countPageLabel () {
      return this.isPaging ? `  ${this.countFrom}〜${this.countTo}名まで表示中` : ''
    }
  },
  watch: {
    displayCount (val) {
      this.$set(this, 'selectLength', val)
    }
  },
  methods: {
    allCheckedOn () {
      this.$emit('selectedMembers', this.selectLength, true)
    },
    allCheckedOff () {
      this.$emit('selectedMembers', this.displayCount, false)
    }
  }
}
</script>
